export default "__VITE_ASSET__D40jQu0a__"